(function (root, factory) {
        if (typeof define === 'function' && define.amd) {
            // AMD. Register as an anonymous module.
            define([], factory);
        } else if (typeof module === 'object' && module.exports) {
            // Node. Does not work with strict CommonJS, but
            // only CommonJS-like environments that support module.exports,
            // like Node.
            module.exports = factory();
        } else {
            // Browser globals (root is window)
            root.returnExports = factory();
        }
    }(typeof self !== 'undefined' ? self : this, function () {
        // Just return a value to define the module export.
        // This example returns an object, but the module
        // can return a function as the exported value.
        'use strict';
        var skins = {};
         skins['wysiwyg.viewer.skins.audioplayer.Audio3DPlayer'] = {
  "react": [
    [
      "button",
      "mediaButton",
      [],
      {},
      [
        "div",
        null,
        [
          "_first"
        ],
        {},
        [
          "div",
          null,
          [
            "_second"
          ],
          {},
          [
            "div",
            null,
            [
              "_gradient"
            ],
            {}
          ]
        ],
        [
          "span",
          null,
          [],
          {}
        ]
      ]
    ]
  ],
  "params": {
    "trans": "TRANSITION",
    "bg": "BG_COLOR_ALPHA",
    "rd": "BORDER_RADIUS",
    "shd": "BOX_SHADOW",
    "iconh": "BORDER_COLOR",
    "bgh": "BG_COLOR_ALPHA",
    "shd1": "BOX_SHADOW",
    "tdr": "URL",
    "shd2": "BOX_SHADOW",
    "icon": "BORDER_COLOR",
    "bgh2": "BG_COLOR",
    "bg2": "BG_COLOR"
  },
  "paramsDefaults": {
    "trans": "background-color 0.3s ease 0s, color 0.3s ease 0s",
    "bg": "color_17",
    "rd": "3px",
    "shd": "0 1px 4px rgba(0, 0, 0, 0.6)",
    "iconh": "color_15",
    "bgh": "color_18",
    "shd1": "inset 0 1px 4px 2px rgba(0, 0, 0, 0.2)",
    "tdr": "BASE_THEME_DIRECTORY",
    "shd2": "inset 0 1px 15px -3px rgba(255, 255, 255, 0.6), inset 0 3px 2px -2px rgba(255, 255, 255, 0.7)",
    "icon": "color_15",
    "bgh2": [
      "bgh"
    ],
    "bg2": [
      "bg"
    ]
  },
  "paramsMutators": {
    "bgh2": {
      "type": "alpha",
      "value": 0.75,
      "param": "bgh"
    },
    "bg2": {
      "type": "alpha",
      "value": 0.75,
      "param": "bg"
    }
  },
  "css": {
    "%": "box-sizing:border-box;-webkit-user-select:none;-ms-user-select:none;user-select:none;text-align:center;cursor:pointer !important;[trans]  background-color:[bg];[rd]  [shd]",
    "%:hover,%[data-preview~=\"hover\"]": "color:[iconh];background-color:[bgh];",
    "%:hover span,%[data-preview~=\"hover\"] span": "color:[iconh];",
    "%:hover %_gradient,%[data-preview~=\"hover\"] %_gradient": "background-color:[bgh2];",
    "%:active": "background-image:none;background-color:[bgh];[shd1]",
    "%:active %_gradient": "opacity:0;",
    "%_first,%_second": "background:transparent url([tdr]indented_bg_inverted2.png) repeat-x;[rd]  position:absolute;top:0;right:0;bottom:0;left:0;",
    "%_first": "background-position:center top;",
    "%_second": "background-position:center bottom;",
    "% div": "min-width:15px;min-height:15px;",
    "% span": "box-sizing:border-box;display:block;line-height:18px;height:14px;position:absolute;top:50%;left:50%;text-align:center;font-size:16px;font-weight:bold;",
    "%mediaButton": "width:100%;height:100%;",
    "%mediaButton %_gradient": "[trans]    background-color:[bg2];[rd]    [shd2]    position:absolute;top:3px;right:3px;bottom:3px;left:3px;",
    "%[data-state~=\"loading\"] %mediaButton": "display:none;",
    "%[data-state~=\"pausing\"] %mediaButton span,%[data-state~=\"waiting\"] %mediaButton span": "width:0;height:0;border:6px solid transparent;border-left:13px solid [icon];margin-top:-5px;margin-left:-5px;",
    "%[data-state~=\"pausing\"]:hover %mediaButton span,%[data-state~=\"pausing\"][data-preview~=\"hover\"] %mediaButton span,%[data-state~=\"waiting\"]:hover %mediaButton span,%[data-state~=\"waiting\"][data-preview~=\"hover\"] %mediaButton span": "border-left:13px solid [iconh];",
    "%[data-state~=\"playing\"] %mediaButton span": "border:4px solid [icon];border-top:0;border-bottom:0;width:11px;margin-left:-6px;margin-top:-6px;",
    "%[data-state~=\"playing\"]:hover %mediaButton span,%[data-state~=\"playing\"][data-preview~=\"hover\"] %mediaButton span": "border-left:13px solid [iconh];"
  }
}
 skins['wysiwyg.viewer.skins.audioplayer.BoldPlayer'] = {
  "react": [
    [
      "button",
      "mediaButton",
      [],
      {},
      [
        "span",
        null,
        [],
        {}
      ]
    ]
  ],
  "params": {
    "brw": "BORDER_SIZE",
    "brd": "BORDER_COLOR_ALPHA",
    "trans": "TRANSITION",
    "bg": "BG_COLOR_ALPHA",
    "rd": "BORDER_RADIUS",
    "shd": "BOX_SHADOW",
    "bgh": "BG_COLOR_ALPHA",
    "brdh": "BORDER_COLOR_ALPHA",
    "tdr": "URL"
  },
  "paramsDefaults": {
    "brw": "0",
    "brd": "color_15",
    "trans": "border-color 0.4s ease 0s, background-color 0.4s ease 0s",
    "bg": "color_17",
    "rd": "0",
    "shd": "0 1px 4px rgba(0, 0, 0, 0.6)",
    "bgh": "color_18",
    "brdh": "color_15",
    "tdr": "BASE_THEME_DIRECTORY"
  },
  "css": {
    "%": "box-sizing:border-box;-webkit-user-select:none;-ms-user-select:none;user-select:none;border:[brw] solid [brd];cursor:pointer !important;[trans]  background-color:[bg];[rd]  [shd]",
    "%:hover,%[data-preview~=\"hover\"],%:active": "background-color:[bgh];",
    "%:hover,%[data-preview~=\"hover\"]": "border:solid [brdh] [brw];",
    "% div": "position:absolute;top:0;right:0;bottom:0;left:0;",
    "% span": "box-sizing:border-box;display:block;width:100%;height:20px;position:absolute;top:50%;margin-left:0;margin-top:-9px;",
    "%mediaButton": "width:100%;height:100%;",
    "%[data-state~=\"loading\"] %mediaButton": "display:none;",
    "%[data-state~=\"pausing\"] %mediaButton span,%[data-state~=\"waiting\"] %mediaButton span": "background:url([tdr]play_shadow_small2.png) no-repeat 50% 50%;",
    "%[data-state~=\"playing\"] %mediaButton span": "background:url([tdr]pause_shadow_small2.png) no-repeat 50% 50%;"
  }
}
 skins['wysiwyg.viewer.skins.audioplayer.ShinyPlayer'] = {
  "react": [
    [
      "button",
      "mediaButton",
      [],
      {},
      [
        "span",
        null,
        [],
        {}
      ]
    ]
  ],
  "params": {
    "bg": "BG_COLOR_ALPHA",
    "tdr": "URL",
    "brw": "BORDER_SIZE",
    "brd": "BORDER_COLOR_ALPHA",
    "trans": "TRANSITION",
    "rd": "BORDER_RADIUS",
    "shd": "BOX_SHADOW",
    "brdh": "BORDER_COLOR_ALPHA",
    "iconh": "BORDER_COLOR",
    "bgh": "BG_COLOR_ALPHA",
    "shd1": "BOX_SHADOW",
    "icon": "BORDER_COLOR"
  },
  "paramsDefaults": {
    "bg": "color_17",
    "tdr": "BASE_THEME_DIRECTORY",
    "brw": "0",
    "brd": "color_15",
    "trans": "border-color 0.4s ease 0s, background-color 0.4s ease 0s, color 0.4s ease 0s",
    "rd": "0",
    "shd": "0 1px 4px rgba(0, 0, 0, 0.6)",
    "brdh": "color_15",
    "iconh": "color_15",
    "bgh": "color_18",
    "shd1": "inset 0 1px 4px 1px rgba(0, 0, 0, 0.2)",
    "icon": "color_15"
  },
  "css": {
    "%": "box-sizing:border-box;-webkit-user-select:none;-ms-user-select:none;user-select:none;background:[bg] url([tdr]shiny1button_bg.png) 50% 50% repeat-x;text-align:center;cursor:pointer !important;border:[brw] solid [brd];[trans]  [rd]  [shd]",
    "%:hover,%[data-preview~=\"hover\"]": "border-color:[brdh];color:[iconh];background-color:[bgh];",
    "%:hover %playButton span,%[data-preview~=\"hover\"] %playButton span": "border:6px solid transparent;border-left:13px solid [iconh];",
    "%:hover %pauseButton span,%[data-preview~=\"hover\"] %pauseButton span": "border:solid [iconh];border-width:0 4px;",
    "%:active": "background-image:none;background-color:[bgh];[shd1]",
    "% div": "min-width:15px;min-height:15px;position:absolute;top:0;right:0;bottom:0;left:0;",
    "% span": "box-sizing:border-box;display:block;position:absolute;top:50%;left:50%;margin-top:-6px;",
    "%mediaButton": "width:100%;height:100%;",
    "%[data-state~=\"loading\"] %mediaButton": "display:none;",
    "%[data-state~=\"pausing\"] %mediaButton span,%[data-state~=\"waiting\"] %mediaButton span": "width:0;height:0;border:6px solid transparent;border-left:13px solid [icon];margin-left:-5px;",
    "%[data-state~=\"pausing\"]:hover %mediaButton span,%[data-state~=\"pausing\"][data-preview~=\"hover\"] %mediaButton span,%[data-state~=\"waiting\"]:hover %mediaButton span,%[data-state~=\"waiting\"][data-preview~=\"hover\"] %mediaButton span": "border:6px solid transparent;border-left:13px solid [iconh];",
    "%[data-state~=\"playing\"] %mediaButton span": "border:solid [icon];border-width:0 4px;height:14px;width:11px;margin-left:-6px;",
    "%[data-state~=\"playing\"] %mediaButton span:hover,%[data-state~=\"playing\"] %mediaButton span[data-preview~=\"hover\"]": "border:4px solid [iconh];border-top:0;border-bottom:0;",
    "%[data-state~=\"playing\"]:hover %mediaButton span,%[data-state~=\"playing\"][data-preview~=\"hover\"] %mediaButton span": "border:6px solid transparent;border-left:13px solid [iconh];"
  }
}
 skins['wysiwyg.viewer.skins.audioplayer.SimplePlayer'] = {
  "react": [
    [
      "button",
      "mediaButton",
      [],
      {},
      [
        "span",
        null,
        [],
        {}
      ]
    ]
  ],
  "params": {
    "trans": "TRANSITION",
    "brw": "BORDER_SIZE",
    "brd": "BORDER_COLOR_ALPHA",
    "bg": "BG_COLOR_ALPHA",
    "rd": "BORDER_RADIUS",
    "shd": "BOX_SHADOW",
    "brdh": "BORDER_COLOR_ALPHA",
    "bgh": "BG_COLOR_ALPHA",
    "icon": "BORDER_COLOR",
    "iconh": "BORDER_COLOR"
  },
  "paramsDefaults": {
    "trans": "border-color 0.4s ease 0s, background-color 0.4s ease 0s, color 0.4s ease 0s",
    "brw": "0",
    "brd": "color_15",
    "bg": "color_17",
    "rd": "0",
    "shd": "0 1px 4px rgba(0, 0, 0, 0.6)",
    "brdh": "color_15",
    "bgh": "color_18",
    "icon": "color_15",
    "iconh": "color_15"
  },
  "css": {
    "%": "box-sizing:border-box;-webkit-user-select:none;-ms-user-select:none;user-select:none;text-align:center;cursor:pointer !important;[trans]  border:[brw] solid [brd];background-color:[bg];[rd]  [shd]",
    "%:hover,%[data-preview~=\"hover\"]": "border-color:[brdh];background-color:[bgh];",
    "% div": "position:absolute;top:0;right:0;bottom:0;left:0;",
    "% span": "box-sizing:border-box;display:block;line-height:18px;height:14px;position:absolute;top:50%;left:50%;text-align:center;font-size:16px;font-weight:bold;",
    "%mediaButton": "width:100%;height:100%;",
    "%[data-state~=\"loading\"] %mediaButton": "display:none;",
    "%[data-state~=\"pausing\"] %mediaButton span,%[data-state~=\"waiting\"] %mediaButton span": "width:0;height:0;border:11px solid transparent;border-left:13px solid [icon];margin-top:-11px;margin-left:-5px;",
    "%[data-state~=\"pausing\"]:hover %mediaButton span,%[data-state~=\"pausing\"][data-preview~=\"hover\"] %mediaButton span,%[data-state~=\"waiting\"]:hover %mediaButton span,%[data-state~=\"waiting\"][data-preview~=\"hover\"] %mediaButton span": "border-left:13px solid [iconh];",
    "%[data-state~=\"playing\"] %mediaButton span": "border:solid [icon];border-width:0 4px;width:11px;margin-left:-6px;margin-top:-6px;",
    "%[data-state~=\"playing\"]:hover %mediaButton span,%[data-state~=\"playing\"][data-preview~=\"hover\"] %mediaButton span": "border-left:4px solid [iconh];border-right:4px solid [iconh];"
  }
}
 skins['wysiwyg.viewer.skins.AudioPlayerMinimalSkin'] = {
  "react": [
    [
      "ul",
      null,
      [],
      {},
      [
        "li",
        "playButton",
        [],
        {}
      ],
      [
        "li",
        "pauseButton",
        [],
        {}
      ],
      [
        "li",
        "stopButton",
        [],
        {}
      ]
    ]
  ],
  "params": {
    "rd": "BORDER_RADIUS"
  },
  "paramsDefaults": {
    "rd": "10px"
  },
  "css": {
    "% ul": "list-style-type:none;margin:0;padding:0;",
    "% li": "padding:10px;margin-left:3px;border:solid 2px #accdef;cursor:pointer;background:#accdef;[rd]  position:relative;",
    "% li:hover": "border-color:#c33;",
    "%playButton": "background:#770;display:inline-block;",
    "%pauseButton": "background:rgba(0, 255, 0, 0.8);display:none;",
    "%stopButton": "background:rgba(0, 0, 255, 0.8);display:inline-block;",
    "%[data-state=\"playing\"] %playButton": "display:none;",
    "%[data-state=\"playing\"] %pauseButton": "display:inline-block;"
  }
}

        return skins;
    }));